module.exports = __webpack_public_path__ + "static/media/tanque-rojo.ca1bf91d.svg";